module.exports = __webpack_public_path__ + "img/banner-two8.f8b8ca5f.png";